$(".entry-content a[href^='#']:not(.noscroll)").on("click", function(e) {
    e.preventDefault();
    href = $(this).attr("href");
    target = $(href);
    $offset = target.data('offset');

    if ($(this).hasClass('use-data-offset')) {
        $offset = $(this).data('offset');                    
    }

    if (!$offset) {
        if ($(window).width() < 981) {
            $offset = 95;
        } else {
            $offset = 120;
        }
    }

    if (href.length > 1) {
        $("html, body").animate(
            {
                scrollTop: target.offset().top - $offset
            },
            500
        );
    }
});




var lastId,
    topMenu = $(".jump-to-menu"),
    menuItems = topMenu.find("a");

// All list items

    // Anchors corresponding to menu items
    var scrollItems = menuItems.map(function() {
        var href = $(this).attr("href");
        if (href.lastIndexOf("#", 0) === 0) {
            // make sure the href length is greater than 1 (avoid single pound character link errors)
            if (href.length > 1) {
                var item = $(href);
                // check if we actually have the element on the page
                if (item.length > 0) {
                    return item;
                }
            }
        }
    });

// Bind to scroll
$(window).on("scroll", function() {
    // Get container scroll position
    var fromTop = $(this).scrollTop() + 250;

    // Get id of current scroll item
    var cur = scrollItems.map(function() {
        if ($(this).offset().top < fromTop) {
            return this;
        }
    });
    // Get the id of the current element
    cur = cur[cur.length - 1];
    var id = cur && cur.length ? cur[0].id : "";

    if (lastId !== id) {
        lastId = id;
        lastIdElement = $("[href='#" + id + "']");
        // Set/remove active class
        menuItems
            .parent()
            .removeClass("active")
            .end()
            .filter(lastIdElement)
            .parent()
            .addClass("active");

    }
});